import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { DataManager, ODataV4Adaptor } from '@syncfusion/ej2-data';
import { PageSettingsModel } from '@syncfusion/ej2-grids';

import { CrawfordGridComponent, GridColumn, CrawfordSnackbarService, CrawfordSpinnerService,
  CrawfordApiGridAdaptor, ApiGridParameters, ITabComponent } from 'crawford-shell';

import { ClaimService } from '../claim.service';

@Component({
  selector: 'app-associated-claims',
  templateUrl: './associated-claims.component.html',
  styleUrls: ['./associated-claims.component.scss']
})
export class AssociatedClaimsComponent implements OnInit, ITabComponent {

  @Input() public crawfordRef: string;
  @Input() public source: string;
  @ViewChild('ccogrid') public ccoGrid: CrawfordGridComponent;

  public headerText = 'Linked Files';

  public adaptor: CrawfordApiGridAdaptor;
  public dataSource: DataManager;
  private dataLoaded = false;

  public displayColumns: GridColumn[] = [
    new GridColumn('linkedFileRef', 'Crawford Reference'),
    new GridColumn('insurerRef', 'Insurer Reference'),
    new GridColumn('status', 'Status'),
    new GridColumn('serviceLine', 'Service Line')
  ];

  public sortingSettings: any = {
    columns: [{field: 'linkedFileRef', direction: 'ascending' }]
  };

  public pagerSettings: PageSettingsModel = {
    pageSize: 10
  };

  constructor(
      private router: Router,
      private claimService: ClaimService,
      private snackbarService: CrawfordSnackbarService,
      private spinnerService: CrawfordSpinnerService
  ) {
  }

  loadData() {
    if (!this.dataLoaded) {
      this.spinnerService.show('claimAssociatedClaimsSpinner');
      this.adaptor = this.initializeAdaptor();

      this.adaptor.setAdditionalParameters({
        crawfordRefs: [ this.crawfordRef ],
        claimDataSource: this.source
      });

      this.dataSource = this.claimService.getAssociatedClaimsDataManager(this.adaptor);
      this.dataLoaded = true;
    }
  }

  private initializeAdaptor(): CrawfordApiGridAdaptor {
    const parameters = new ApiGridParameters();
    parameters.top = this.pagerSettings.pageSize;
    parameters.orderBy.columnName = this.sortingSettings.field;
    parameters.orderBy.direction = this.sortingSettings.direction;

    return new CrawfordApiGridAdaptor(parameters);
  }

  ngOnInit() {  }

  onActionFailure($event): void {
    this.snackbarService.displayErrorMessage($event.error);
    this.spinnerService.hide('claimAssociatedClaimsSpinner');
  }

  onRowDataBound($event): void {
    const claim = $event.data;
    const row = $event.row;

    if (!claim.userHasPermission) {
      row.classList.add('no-permission');
    }
  }

  onRowSelected($event): void {
    const claim = $event.data;

    if (claim.userHasPermission) {
      this.loadClaimDetails(claim.linkedFileRef);
      this.dataLoaded = false;
      this.crawfordRef = claim.linkedFileRef;
      this.loadData();
    } else {
      this.snackbarService.displayWarningMessage('You do not have permission to view claim ' + claim.crawfordRef);
    }
  }

  loadClaimDetails(crawfordRef: string): void {
    this.router.navigate(['claim/search/', crawfordRef]);
  }

  onDataBound($event: any): void {
    if ($event.totalRecordCount === 0) {
      this.headerText = 'No Associated Claims';
    } else {
      this.headerText = 'Associated Claims';
    }
    this.spinnerService.hide('claimAssociatedClaimsSpinner');
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/UI/src/app/claim/associated-claims/associated-claims.component.ts